import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import { AuthProvider } from "./auth/AuthContext";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import ErrorBoundary from "./components/common/ErrorBoundary";
import { initSentry } from "./utils/errorTracking";
import { initGA, initPlausible } from "./utils/analytics";
import { registerSW } from "virtual:pwa-register";

registerSW({
  onNeedRefresh() {
    console.log("A new version of OurShopHub is available.");
  },

  onOfflineReady() {
    console.log("OurShopHub is ready to work offline.");
  },
});

// Initialize error tracking (Sentry)
initSentry();

// Initialize analytics (choose one or both)
initGA(); // Google Analytics
initPlausible(); // Plausible Analytics (privacy-friendly)

// Create a React Query client
const queryClient = new QueryClient();

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <App />
        </AuthProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
